import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateResource = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Resource'
      fields={fields}
      apiPath='admin/resources'
      successRedirectPath={resource => `/write-now/resources/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateResource
